import { render, staticRenderFns } from "./DiscountEdit.vue?vue&type=template&id=20c47ab8"
import script from "./DiscountEdit.vue?vue&type=script&lang=js"
export * from "./DiscountEdit.vue?vue&type=script&lang=js"
import style0 from "./DiscountEdit.vue?vue&type=style&index=0&id=20c47ab8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports